import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { OrderContext } from '../../store/OrderProvider';
import { DynamicPriceType, ExcursionPickupType } from '../../models/types';
import InfoDescription from '../../components/InfoDescription';
import Price, { CURRENCY } from '../../components/Price';
import DateFormat from '../../components/DateFormat';
import Field from '../../components/Field';
import { RepositoryContext } from '../../store/RepositoryProvider';

const ConfirmOrder = ({ onNext, onClose }) => {
  const {t} = useTranslation(['common', 'order']);

  const orderInfo = useContext(OrderContext);
  const repository = useContext(RepositoryContext);

  const [place, setPlace] = useState(null);
  const [subdivision, setSubdivision] = useState(null);
  const [excursion, setExcursion] = useState(null);
  const [, setSchedule] = useState(null);
  const [discount, setDiscount] = useState(null);
  const [passengers, setPassengers] = useState([]);

  const loadPassengers = async () => {
    let passengers = orderInfo.getSession().passengers?.reduce((p, passenger) => {
      p[passenger.price] = p[passenger.price] ?? {price:passenger.price, count:0, ages:[]};
      p[passenger.price].count += passenger.count;
      p[passenger.price].ages.push(...(passenger.ages ?? []));
      return p;
    }, {});

    if (passengers) {
      let list = Object.values(passengers);
      for (let i = 0; i < list.length; ++i) {
        list[i].title = '';
        try {
          let l = await repository.getModel('Price', list[i].price);
          list[i].title = l?.value.title;
        } catch(e) {}
      }
      setPassengers(list);
    }
  };

  useEffect(() => {
    orderInfo.getSchedule().then((schedule) => {
      setSchedule(schedule);
      let place = schedule.getPlaces().find((place) => orderInfo.getSession().place && place.place.id === orderInfo.getSession().place);
      setPlace(place);
    });
    repository.getModel('Subdivision', orderInfo.getSession().subdivision).then((model) => {
      setSubdivision(model?.value ?? null);
    });
    repository.getModel('Excursion', orderInfo.getSession().excursion).then((model) => {
      setExcursion(model?.value ?? null);
    });
    repository.getModel('Discount', orderInfo.getSession().discount).then((model) => {
      setDiscount(model?.value ?? null);
    });
    loadPassengers();
  }, []);

  return (
    <div className="trip-app">
      <div className="trip-app-body">
        <table>
          <tbody>
            <tr>
              <td>
                <InfoDescription description={t('order:new_order.in_check')}>
                  <Price currency={CURRENCY.RUB} value={orderInfo.getPaymentAmount()} />
                </InfoDescription>
              </td>
              <td>
                <InfoDescription description={t('order:new_order.seats')}>
                  {orderInfo.getSession().schedule ? orderInfo.getSeatNumbers().join(', ') : '-'}
                </InfoDescription>
              </td>
            </tr>
          </tbody>
        </table>
        <hr/>
        <Field title={t('order:confirm_order.trip')}>
          <span className='comma'>{subdivision?.title}</span>
          <span className='comma'>{excursion?.title}</span>
        </Field>
        <Field title={t('order:confirm_order.client')}>
          {orderInfo.getSession().phone} - {orderInfo.getSession().name}
        </Field>
        <Field title={t('order:confirm_order.passengers')}>
          {passengers?.map((passenger) => (
            <span key={passenger.price} className='comma'>{passenger.count} {passenger.title}</span>
          ))}
        </Field>
        <Field title={t('order:confirm_order.place')}>
          {orderInfo.getOrderInfo().excursion && orderInfo.getOrderInfo().excursion.pickupType === ExcursionPickupType.HOME && (
            <span>{orderInfo.getSession().address}</span>
          )}
          {orderInfo.getOrderInfo().excursion && orderInfo.getOrderInfo().excursion.pickupType === ExcursionPickupType.PLACE && (
            <span>{place?.place.title}</span>
          )}
        </Field>
        <Field title={t('order:confirm_order.place_date')}>
          <DateFormat.Day date={orderInfo.getSession().date}/>, {place?.time ?? orderInfo.getSession().time}
        </Field>
        <Field title={t('order:confirm_order.comment')}>
          {orderInfo.getSession().comment || '-'}
        </Field>
        <Field title={t('order:confirm_order.additional')}>
          <>
            <div className="toggle-list">
              {orderInfo.getSession().wishes.map((wish, i) => (
                <span key={i} className='comma'>{t(`order:wishes.${wish}`)}</span>
              ))}
            </div>
            {orderInfo.getSession().discount && (
              <div>
                {discount && (
                  <span>
                    {`${discount.title} - ${discount.discount.type === DynamicPriceType.PERCENT ? `${discount.discount.value}%` : Price.Text({ currency: CURRENCY.RUB, value: discount.discount.value })}`}
                  </span>
                )}
              </div>
            )}
          </>
        </Field>
      </div>
    </div>
  );
}

ConfirmOrder.propTypes = {
  onNext: PropTypes.func,
  onClose: PropTypes.func,
};

export default ConfirmOrder;